export default __webpack_public_path__ + "static/media/avatar_2025.8a2de139.png";